import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import * as React from 'react';
import { getCollectionDefinition, getWebSolutionData, extractTagsDefinition, } from '@wix/app-market-collection-widget';
import s from './style.scss';
import { getWebSolutionsBiData } from '../biData';
import { biLogger } from '../../../bi';
import { withMarketplaceStore, } from '../../../component-decorators/with-marketplace-store';
import { SolutionGridWrapper } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { Heading, Layout, Cell } from 'wix-style-react';
import { getBundleAppSavedPrice, isBundleAppAndInstalled, isBundleAppAndNotInstalled, isBundleAppWithVoucher, } from '../../../common/utils';
import { getRandomRecommendations, getRecommendations, getRecommendationsFromML, getRecommendationsWithoutBS, } from '../../../api/api';
import { withExperiments } from '../../../component-decorators/with-experiments';
import { SeeMoreApps } from './see-more-apps';
export var solutionsSectionDTOtoProps = function (sectionDTO, marketplaceStore, locale, signedInstance, impressionId) {
    var tagData = sectionDTO.tagData;
    var tagsToWebSolutions = tagData.tagsToWebSolutions;
    var _a = tagsToWebSolutions[0].webSolutions, tagsAndSubCategories = _a.tagsAndSubCategories, webSolutions = _a.webSolutions;
    var rootTagDefinition = getCollectionDefinition(tagsAndSubCategories[0].tag);
    var innerTagsDefinitions = extractTagsDefinition(tagsToWebSolutions);
    var webSolutionsData = webSolutions.map(function (solution, appIndex) {
        var _a;
        return (__assign(__assign({}, getWebSolutionData(solution)), { appIndex: appIndex, showPremiumLabel: !marketplaceStore.siteIsPremium &&
                solution.baseInfo.pricing.isRequiredWixPremium, isInstalled: !!(marketplaceStore.installedApps &&
                ((_a = marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.findIndex(function (installedApp) {
                    return installedApp.webSolutionBase.id === solution.baseInfo.id;
                })) > -1), isBundleAppNotInstalled: isBundleAppAndNotInstalled(solution.baseInfo.id, marketplaceStore.bundleApps), isBundleAppInstalled: isBundleAppAndInstalled(solution.baseInfo.id, marketplaceStore.bundleApps), savedPrice: getBundleAppSavedPrice(solution.baseInfo.id, marketplaceStore.bundleApps), isVoucherApp: isBundleAppWithVoucher(solution.baseInfo.id, marketplaceStore.bundleApps) }));
    });
    return {
        rootTagDefinition: rootTagDefinition,
        webSolutions: webSolutionsData,
        innerTagsDefinitions: innerTagsDefinitions,
        locale: locale,
        signedInstance: signedInstance,
        collimp_id: impressionId,
    };
};
var Solution = /** @class */ (function (_super) {
    __extends(Solution, _super);
    function Solution(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchRecommendedApps = function () { return __awaiter(_this, void 0, void 0, function () {
            var apps, fetchRecommendationsWithoutBS;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        fetchRecommendationsWithoutBS = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.experiments) === null || _b === void 0 ? void 0 : _b.enabled('specs.marketplace.exclude-bs-from-recommendations');
                        if (!fetchRecommendationsWithoutBS) return [3 /*break*/, 2];
                        return [4 /*yield*/, getRecommendationsWithoutBS((_c = this.props) === null || _c === void 0 ? void 0 : _c.signedInstance, (_d = this.props) === null || _d === void 0 ? void 0 : _d.locale, 6)];
                    case 1:
                        apps = _f.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        apps = getRecommendations(this.props.signedInstance, (_e = this.props) === null || _e === void 0 ? void 0 : _e.locale, 6);
                        _f.label = 3;
                    case 3: return [2 /*return*/, apps];
                }
            });
        }); };
        _this.state = {
            webSolutions: _this.props.webSolutions,
            showImpression: true,
        };
        return _this;
    }
    Solution.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, rootTagDefinition, marketplaceStore, locale, signedInstance, experiments, collimp_id, webSolutions, fetchRandomApps, randomApps, _b, recommendedApps, _c, dynamicWebSolutions, parsedWebSolutions, appIds, appIdsList;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props, rootTagDefinition = _a.rootTagDefinition, marketplaceStore = _a.marketplaceStore, locale = _a.locale, signedInstance = _a.signedInstance, experiments = _a.experiments, collimp_id = _a.collimp_id;
                        webSolutions = this.state.webSolutions;
                        if (!(rootTagDefinition.slug === 'user-recommendations' &&
                            webSolutions.length === 0)) return [3 /*break*/, 7];
                        fetchRandomApps = experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.ml-random-apps');
                        if (!fetchRandomApps) return [3 /*break*/, 2];
                        return [4 /*yield*/, getRandomRecommendations('4', locale, signedInstance)];
                    case 1:
                        _b = _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _b = [];
                        _d.label = 3;
                    case 3:
                        randomApps = _b;
                        if (!!fetchRandomApps) return [3 /*break*/, 5];
                        return [4 /*yield*/, getRecommendationsFromML('4', locale, signedInstance)];
                    case 4:
                        _c = _d.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _c = { data: [] };
                        _d.label = 6;
                    case 6:
                        recommendedApps = _c;
                        dynamicWebSolutions = fetchRandomApps
                            ? randomApps
                            : recommendedApps.webSolutions;
                        if (dynamicWebSolutions === null || dynamicWebSolutions === void 0 ? void 0 : dynamicWebSolutions.length) {
                            parsedWebSolutions = dynamicWebSolutions.map(function (solution, appIndex) { return (__assign(__assign({}, getWebSolutionData(solution)), { appIndex: appIndex, showPremiumLabel: !marketplaceStore.siteIsPremium &&
                                    solution.baseInfo.pricing.isRequiredWixPremium })); });
                            if (this.state.showImpression) {
                                appIds = parsedWebSolutions.map(function (webSolution) { return webSolution.id; });
                                appIdsList = appIds === null || appIds === void 0 ? void 0 : appIds.join(',');
                                biLogger.appMarketAppCollectionImpressions({
                                    apps_list: appIdsList,
                                    collimp_id: collimp_id,
                                    number_of_apps: 4,
                                    tag_name: 'user-recommendations',
                                    tag_type: 'homepage',
                                    collection_index: 1,
                                    prediction_type: fetchRandomApps ? 'random_apps' : recommendedApps.predictionType
                                });
                                this.setState({ showImpression: false });
                            }
                            this.setState({ webSolutions: parsedWebSolutions });
                        }
                        _d.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Solution.prototype.render = function () {
        var _a = this.props, rootTagDefinition = _a.rootTagDefinition, marketplaceStore = _a.marketplaceStore, collimp_id = _a.collimp_id;
        var webSolutions = this.state.webSolutions;
        var biData = getWebSolutionsBiData(webSolutions, 'box', rootTagDefinition.slug, marketplaceStore.metaSiteId, marketplaceStore.route, marketplaceStore.prevRoute, marketplaceStore.bundleApps, collimp_id);
        var shouldShowMoreAppsButton = rootTagDefinition.slug !== 'user-recommendations';
        return (React.createElement("div", { "data-hook": rootTagDefinition.slug, className: s.section },
            React.createElement(Layout, null,
                React.createElement(Cell, { span: 9 },
                    React.createElement(Heading, { appearance: "H2", dataHook: "widget-title", className: s.widgetTitle }, rootTagDefinition.name)),
                React.createElement(Cell, { span: 1 }),
                React.createElement(Cell, { span: 2 }, shouldShowMoreAppsButton && (React.createElement(SeeMoreApps, { slug: rootTagDefinition.slug, gridType: rootTagDefinition.type })))),
            React.createElement(Layout, null,
                React.createElement(Cell, null,
                    React.createElement("span", { className: s.widgetWrapper },
                        React.createElement(SolutionGridWrapper, { solutions: webSolutions.map(function (solution, appIndex) {
                                return __assign({ appIndex: appIndex }, solution);
                            }), solutionsBiData: biData, isCompany: true, isFull: true, collimp_id: collimp_id, referralSectionName: rootTagDefinition.slug }),
                        shouldShowMoreAppsButton && (React.createElement(SeeMoreApps, { slug: rootTagDefinition.slug, gridType: rootTagDefinition.type, positionBottom: true })))))));
    };
    Solution = __decorate([
        withMarketplaceStore,
        withExperiments
    ], Solution);
    return Solution;
}(React.Component));
export { Solution };
//# sourceMappingURL=solution-grid-homepage.js.map